import { ILoadableWrapper, ISite, Loadable, createDefaultLoadable, toLoadableWrapper } from '../../models';
import { ILoadableArray } from '../../models/loadable';
import { ISensor } from '../../models/sensor.interface';

export const SELECTED_SITE_KEY: string = "selectedSite"
export const SITES_KEY: string = "sites"
export const SHOW_RULES_ON_PATROL_KEY: string = "showRulesOnPatrol";

export type StatisticMap = {[key: string] : IStatistic}
export type LoadableSensors = ILoadableArray<ILoadableWrapper<ISensor>>
export type SensorMap = Record<string, LoadableSensors>

export interface IStatistic {
    last_alert_timestamp: string,
    last_alert_id: string,
    number_of_alerts_this_week: number,
    number_of_alerts_past_24hrs: number,
    weekly_reset_done: number
}

export interface SitesState extends Loadable {
    sites: Record<string, ISite & Loadable>,
    selectedSite: string | null,
    sensors: SensorMap,
    showRulesOnPatrol: boolean,
    // Statistics State
    sensorStatistics: ILoadableWrapper<StatisticMap>,
    siteStatistics: ILoadableWrapper<StatisticMap>,
    ruleStatistics: ILoadableWrapper<StatisticMap>,
}


export const initialSiteState: SitesState = {
    ...createDefaultLoadable(),
    sites: JSON.parse(sessionStorage.getItem(SITES_KEY) ?? "{}"),
    selectedSite: sessionStorage.getItem(SELECTED_SITE_KEY),
    sensors: {},
    showRulesOnPatrol: JSON.parse(localStorage.getItem(SHOW_RULES_ON_PATROL_KEY) ?? "false"),
    sensorStatistics: toLoadableWrapper({} as StatisticMap),
    siteStatistics: toLoadableWrapper({} as StatisticMap),
    ruleStatistics: toLoadableWrapper({} as StatisticMap),
};

export const initialSensorState: LoadableSensors = {
    ...createDefaultLoadable(),
    items: [],
}


